module.exports = __webpack_public_path__ + "static/img/backgroundGZ.a56c848f.jpg";